import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import axios from 'axios';
import { Notify } from 'notiflix';
import CommonProfileCard from '../CommonProfileCard/CommonProfileCard';
import { Loading } from 'notiflix/build/notiflix-loading-aio';
import { useRef } from 'react';
function AdvnaceSearch() {
    const [Reload, setReload] = useState(false);
    const [Result, setResult] = useState([]);
    const [Loader, setLoader] = useState(false);
    const [form, setForm] = useState({
        age_from: "",
        age_to: "",
        marital_status: [],
        jathagam_type: [],
        filterbydate: "",
        from_date: "",
        to_date: "",
        profile_category: "",
        color: [],
        kulam: [],
        star: [],
        rasi: []
    });
    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const profilesPerPage = 10

    useEffect(() => {
        const Data = JSON.parse(localStorage.getItem('kkm_advance_search'));
        const Page = localStorage.getItem('kkm_advance_search_page');
        const FormData = JSON.parse(localStorage.getItem('kkm_advance_search_form'));
        if (Data) {
            setResult(Data);
        }
        if (Page) {
            setCurrentPage(Number(Page));
        }
        if (FormData) {
            setForm(FormData);
        }
    }, []);

    useEffect(() => {
        if (Result.length > 0) {
            const lastViewedId = sessionStorage.getItem("last_viewed_profile_id");
            const savedScrollPos = sessionStorage.getItem("all_profiles_scroll_pos");

            if (lastViewedId || savedScrollPos) {
                setTimeout(() => {
                    const element = document.getElementById(`profile-card-${lastViewedId}`);
                    if (element) {
                        element.scrollIntoView({ behavior: "smooth", block: "center" });
                    } else if (savedScrollPos) {
                        window.scrollTo({ top: Number(savedScrollPos), behavior: "smooth" });
                    }
                    sessionStorage.removeItem("last_viewed_profile_id");
                    sessionStorage.removeItem("all_profiles_scroll_pos");
                }, 150);
            }
        }
    }, [Result]);

    const firstRun = useRef(true);

    useEffect(() => {
        if (firstRun.current) {
            firstRun.current = false;
            return;
        }
        handleAdvancedSearch(false);
    }, [Reload]);
    const handleAdvancedSearch = (resetPage = true) => {
        setLoader(true);
        const token = JSON.parse(localStorage.getItem("kkm_auth"));
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .post(
                "https://kovaikongunadumatrimony.com/kkm_backend/public/api/Advance-search",
                form,
                { headers }
            )
            .then((response) => {
                setLoader(false)
                if (response.data.status === true) {
                    let stringifyData = JSON.stringify(response.data.data);
                    localStorage.setItem("kkm_advance_search", stringifyData);
                    localStorage.setItem("kkm_advance_search_form", JSON.stringify(form));
                    setResult(response.data.data);
                    if (resetPage) {
                        setCurrentPage(1); // reset to first page
                        localStorage.setItem("kkm_advance_search_page", 1);
                    }
                    Loading.remove(1923);

                } else {
                    Notify.failure(response.data.message);
                    Loading.remove(1923);
                }
            });
    };

    const indexOfLastProfile = currentPage * profilesPerPage;
    const indexOfFirstProfile = indexOfLastProfile - profilesPerPage;
    const currentProfiles = Result.slice(indexOfFirstProfile, indexOfLastProfile);
    const totalPages = Math.ceil(Result.length / profilesPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            localStorage.setItem('kkm_advance_search_page', page);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const getPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 5;
        const half = Math.floor(maxPagesToShow / 2);

        let start = Math.max(1, currentPage - half);
        let end = Math.min(totalPages, start + maxPagesToShow - 1);

        if (end - start + 1 < maxPagesToShow) {
            start = Math.max(1, end - maxPagesToShow + 1);
        }

        if (start > 1) {
            pages.push(1);
            if (start > 2) pages.push('...');
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (end < totalPages) {
            if (end < totalPages - 1) pages.push('...');
            pages.push(totalPages);
        }

        return pages;
    };

    const RasiList = [
        { label: 'மேஷம்', value: 'மேஷம்' },
        { label: 'ரிஷபம்', value: 'ரிஷபம்' },
        { label: 'மிதுனம்', value: 'மிதுனம்' },
        { label: 'கடகம்', value: 'கடகம்' },
        { label: 'சிம்மம்', value: 'சிம்மம்' },
        { label: 'கன்னி', value: 'கன்னி' },
        { label: 'துலாம்', value: 'துலாம்' },
        { label: 'விருச்சிகம்', value: 'விருச்சிகம்' },
        { label: 'தனுசு', value: 'தனுசு' },
        { label: 'மகரம்', value: 'மகரம்' },
        { label: 'கும்பம்', value: 'கும்பம்' },
        { label: 'மீனம்', value: 'மீனம்' },
    ];

    const JathagamList = [
        { label: 'சுத்தம் ஜாதகம்', value: 'சுத்தம் ஜாதகம்' },
        { label: 'செவ்வாய் ஜாதகம்', value: 'செவ்வாய் ஜாதகம்' },
        { label: 'சுத்தம் ராகு கேது ஜாதகம்', value: 'சுத்தம் ராகு கேது ஜாதகம்' },
        { label: 'ராகு கேது செவ்வாய் ஜாதகம்', value: 'ராகு கேது செவ்வாய் ஜாதகம்' },
        { label: 'பரிகார செவ்வாய் ஜாதகம்', value: 'பரிகார செவ்வாய் ஜாதகம்' },
    ];

    const FilterByDateList = [
        { label: 'Today', value: 'today' },
        { label: 'Yesterday', value: 'yesterday' },
        { label: 'Last 7 Days', value: '7days' },
        { label: 'Last 30 Days', value: '30days' },
        { label: 'Last 1 Year', value: '1year' },
        { label: 'Custom Date', value: 'custom' },
    ];

    const MaritalStatusList = [
        { label: 'Unmarried', value: 'Unmarried' },
        { label: 'Married', value: 'Married' },
        { label: 'Divorced', value: 'Divorced' },
        { label: 'Widowed', value: 'Widowed' },
    ];

    const ProfileCategoryList = [
        { label: 'Farmer Business', value: 'Farmer, Business' },
        { label: 'Doctor', value: 'Doctor' },
        { label: 'Government Job', value: 'Government Job' },
        { label: 'Private Job', value: 'Private Concern' },
        { label: 'Own Business', value: 'Own Business' },
        { label: 'VIP', value: 'vip' },
        { label: 'Foreign', value: 'Foreign' },
        { label: 'IT', value: 'IT Job' },
        { label: 'VVIP', value: 'VVIP' },

    ];

    const NakshatraList = [
        { label: 'அஸ்வினி', value: 'அஸ்வினி' },
        { label: 'பரணி', value: 'பரணி' },
        { label: 'கார்த்திகை', value: 'கார்த்திகை' },
        { label: 'ரோகிணி', value: 'ரோகிணி' },
        { label: 'மிருகசீரிடம்', value: 'மிருகசீரிடம்' },
        { label: 'திருவாதிரை', value: 'திருவாதிரை' },
        { label: 'புனர்பூசம்', value: 'புனர்பூசம்' },
        { label: 'பூசம்', value: 'பூசம்' },
        { label: 'ஆயில்யம்', value: 'ஆயில்யம்' },
        { label: 'மகம்', value: 'மகம்' },
        { label: 'பூரம்', value: 'பூரம்' },
        { label: 'உத்திரம்', value: 'உத்திரம்' },
        { label: 'அஸ்தம்', value: 'அஸ்தம்' },
        { label: 'சித்திரை', value: 'சித்திரை' },
        { label: 'சுவாதி', value: 'சுவாதி' },
        { label: 'விசாகம்', value: 'விசாகம்' },
        { label: 'அனுஷம்', value: 'அனுஷம்' },
        { label: 'கேட்டை', value: 'கேட்டை' },
        { label: 'மூலம்', value: 'மூலம்' },
        { label: 'பூராடம்', value: 'பூராடம்' },
        { label: 'உத்திராடம்', value: 'உத்திராடம்' },
        { label: 'திருவோணம்', value: 'திருவோணம்' },
        { label: 'அவிட்டம்', value: 'அவிட்டம்' },
        { label: 'சதயம்', value: 'சதயம்' },
        { label: 'பூரட்டாதி', value: 'பூரட்டாதி' },
        { label: 'உத்திரட்டாதி', value: 'உத்திரட்டாதி' },
        { label: 'ரேவதி', value: 'ரேவதி' },
    ];

    const KulamList = [
        { label: 'அந்துவன் குலம்', value: 'அந்துவன் குலம்' },
        { label: 'அழகன் குலம்', value: 'அழகன் குலம்' },
        { label: 'ஆட குலம்', value: 'ஆட குலம்' },
        { label: 'ஆதி குலம்', value: 'ஆதி குலம்' },
        { label: 'ஆந்தை குலம்', value: 'ஆந்தை குலம்' },
        { label: 'ஆவ குலம்', value: 'ஆவ குலம்' },
        { label: 'ஆவின் குலம்', value: 'ஆவின் குலம்' },
        { label: 'ஈஞ்சன் குலம்', value: 'ஈஞ்சன் குலம்' },
        { label: 'எண்ணை குலம்', value: 'எண்ணை குலம்' },
        { label: 'ஒழுக்க குலம்', value: 'ஒழுக்க குலம்' },
        { label: 'ஓதாலன் குலம்', value: 'ஓதாலன் குலம்' },
        { label: 'கணக்கன் குலம்', value: 'கணக்கன் குலம்' },
        { label: 'கணவாளன் குலம்', value: 'கணவாளன் குலம்' },
        { label: 'கண்ணந்தை குலம்', value: 'கண்ணந்தை குலம்' },
        { label: 'கண்ணன் குலம்', value: 'கண்ணன் குலம்' },
        { label: 'களிஞ்சி குலம்', value: 'களிஞ்சி குலம்' },
        { label: 'காடை குலம்', value: 'காடை குலம்' },
        { label: 'காரி குலம்', value: 'காரி குலம்' },
        { label: 'கீரன் குலம்', value: 'கீரன் குலம்' },
        { label: 'குயிலர் குலம்', value: 'குயிலர் குலம்' },
        { label: 'குழையர் குலம்', value: 'குழையர் குலம்' },
        { label: 'கூறை குலம்', value: 'கூறை குலம்' },
        { label: 'கோவேந்தர் குலம்', value: 'கோவேந்தர் குலம்' },
        { label: 'சாத்தந்தை குலம்', value: 'சாத்தந்தை குலம்' },
        { label: 'சிலம்பன் குலம்', value: 'சிலம்பன் குலம்' },
        { label: 'செங்கண்ணன் குலம்', value: 'செங்கண்ணன் குலம்' },
        { label: 'செங்குண்ணி குலம்', value: 'செங்குண்ணி குலம்' },
        { label: 'செம்பன் குலம்', value: 'செம்பன் குலம்' },
        { label: 'செம்பூத்தான் குலம்', value: 'செம்பூத்தான் குலம்' },
        { label: 'செல்லன் குலம்', value: 'செல்லன் குலம்' },
        { label: 'செவ்வந்தி குலம்', value: 'செவ்வந்தி குலம்' },
        { label: 'செவ்வாய் குலம்', value: 'செவ்வாய் குலம்' },
        { label: 'சேடன் குலம்', value: 'சேடன் குலம்' },
        { label: 'சேரன் குலம்', value: 'சேரன் குலம்' },
        { label: 'சேரலன் குலம்', value: 'சேரலன் குலம்' },
        { label: 'சோழன் குலம்', value: 'சோழன் குலம்' },
        { label: 'தனஞ்செயன் குலம்', value: 'தனஞ்செயன் குலம்' },
        { label: 'தழிஞ்சி குலம்', value: 'தழிஞ்சி குலம்' },
        { label: 'தூரன் குலம்', value: 'தூரன் குலம்' },
        { label: 'தேவேந்திரன் குலம்', value: 'தேவேந்திரன் குலம்' },
        { label: 'தோடை குலம்', value: 'தோடை குலம்' },
        { label: 'நீருண்ணியர் குலம்', value: 'நீருண்ணியர் குலம்' },
        { label: 'பண்ணை குலம்', value: 'பண்ணை குலம்' },
        { label: 'பதரியர் குலம்', value: 'பதரியர் குலம்' },
        { label: 'பதுமன் குலம்', value: 'பதுமன் குலம்' },
        { label: 'பனங்காடை குலம்', value: 'பனங்காடை குலம்' },
        { label: 'பனையன் குலம்', value: 'பனையன் குலம்' },
        { label: 'பயிரன் குலம்', value: 'பயிரன் குலம்' },
        { label: 'பவழ குலம்', value: 'பவழ குலம்' },
        { label: 'பாண்டியன் குலம்', value: 'பாண்டியன் குலம்' },
        { label: 'பிரழந்தை குலம்', value: 'பிரழந்தை குலம்' },
        { label: 'பில்லன் குலம்', value: 'பில்லன் குலம்' },
        { label: 'பூசன் குலம்', value: 'பூசன் குலம்' },
        { label: 'பூச்சந்தை குலம்', value: 'பூச்சந்தை குலம்' },
        { label: 'பூந்தன் குலம்', value: 'பூந்தன் குலம்' },
        { label: 'பெரிய குலம்', value: 'பெரிய குலம்' },
        { label: 'பெருங்குடி குலம்', value: 'பெருங்குடி குலம்' },
        { label: 'பொடியன் குலம்', value: 'பொடியன் குலம்' },
        { label: 'பொன்னர் குலம்', value: 'பொன்னர் குலம்' },
        { label: 'பொருள்தந்த குலம்', value: 'பொருள்தந்த குலம்' },
        { label: 'மணியன் குலம்', value: 'மணியன் குலம்' },
        { label: 'மயிலர் குலம்', value: 'மயிலர் குலம்' },
        { label: 'மாட குலம்', value: 'மாட குலம்' },
        { label: 'முத்தன் குலம்', value: 'முத்தன் குலம்' },
        { label: 'முல்லை குலம்', value: 'முல்லை குலம்' },
        { label: 'முழுக்காதன் குலம்', value: 'முழுக்காதன் குலம்' },
        { label: 'மூலன் குலம்', value: 'மூலன் குலம்' },
        { label: 'மேதி குலம்', value: 'மேதி குலம்' },
        { label: 'வண்ணக்கன் குலம்', value: 'வண்ணக்கன் குலம்' },
        { label: 'வில்லி குலம்', value: 'வில்லி குலம்' },
        { label: 'விளையன் குலம்', value: 'விளையன் குலம்' },
        { label: 'வெண்டுவன் குலம்', value: 'வெண்டுவன் குலம்' },
        { label: 'வெண்ணை குலம்', value: 'வெண்ணை குலம்' },
        { label: 'வெளியன் குலம்', value: 'வெளியன் குலம்' },
        { label: 'வெள்ளம்பன் குலம்', value: 'வெள்ளம்பன் குலம்' },
        { label: 'வேந்தன் குலம்', value: 'வேந்தன் குலம்' },
        { label: 'கள்ளி குலம்', value: 'கள்ளி குலம்' },
    ];


    const ColorList = [
        { label: 'Very Fair', value: 'Very Fair' },
        { label: 'Fair', value: 'Fair' },
        { label: 'Wheatish', value: 'Wheatish' },
        { label: 'Wheatish Brown', value: 'Wheatish Brown' },
        { label: 'Dark', value: 'Dark' },
    ];
    const AgeOptions = [...Array(43)].map((_, i) => ({
        value: 18 + i,
        label: String(18 + i)
    }));

    const handleFormChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleMultiChange = (name, selectedOptions) => {
        setForm({ ...form, [name]: selectedOptions.map(opt => opt.value) });
    };

    return (
        <>
            <div className="search-card">
                <h5>உங்களுக்கான வரனைத் தேர்ந்தெடுக்கவும்</h5>
                <div className="id-form-grid">

                    <Select
                        options={AgeOptions}
                        placeholder="Age From"
                        onChange={(selected) =>
                            setForm({ ...form, age_from: selected ? selected.value : "" })
                        }
                        value={AgeOptions.find(opt => opt.value === form.age_from) || null}
                    />

                    <Select
                        options={AgeOptions}
                        placeholder="Age To"
                        onChange={(selected) =>
                            setForm({ ...form, age_to: selected ? selected.value : "" })
                        }
                        value={AgeOptions.find(opt => opt.value === form.age_to) || null}
                    />

                    <Select
                        options={JathagamList}
                        isMulti
                        placeholder="Select Jathagam Type"
                        onChange={(selected) => handleMultiChange("jathagam_type", selected)}
                        value={JathagamList.filter(opt => form.jathagam_type.includes(opt.value))}
                    />

                    <Select
                        options={FilterByDateList}
                        placeholder="Select Filter By Date"
                        onChange={(selected) =>
                            setForm({
                                ...form,
                                filterbydate: selected ? selected.value : "",
                                ...(selected?.value !== 'custom' && { from_date: "", to_date: "" })
                            })
                        }
                        value={FilterByDateList.find(opt => opt.value === form.filterbydate) || null}
                    />

                    {form.filterbydate === 'custom' && (
                        <>
                            <input
                                type="date"
                                className="form-control"
                                name="from_date"
                                value={form.from_date}
                                onChange={handleFormChange}
                                placeholder="From Date"
                            />
                            <input
                                type="date"
                                className="form-control"
                                name="to_date"
                                value={form.to_date}
                                onChange={handleFormChange}
                                placeholder="To Date"
                            />
                        </>
                    )}

                    <Select
                        options={MaritalStatusList}
                        isMulti
                        placeholder="Select Marital Status"
                        onChange={(selected) => handleMultiChange("marital_status", selected)}
                        value={MaritalStatusList.filter(opt => form.marital_status.includes(opt.value))}
                    />

                    <Select
                        options={ProfileCategoryList}
                        isMulti
                        placeholder="Select Profile Catogory"
                        onChange={(selected) => handleMultiChange("profile_category", selected)}
                        value={ProfileCategoryList.filter(opt => form.profile_category.includes(opt.value))}
                    />

                    {/* <Select
                        options={NakshatraList}
                        isMulti
                        placeholder="Select Star"
                        onChange={(selected) => handleMultiChange("star", selected)}
                        value={NakshatraList.filter(opt => form.star.includes(opt.value))}
                    /> */}

                    {/* <Select
                        options={RasiList}
                        isMulti
                        placeholder="Select Rasi"
                        onChange={(selected) => handleMultiChange("rasi", selected)}
                        value={RasiList.filter(opt => form.rasi.includes(opt.value))}
                    /> */}

                    {/* <Select
                        options={KulamList}
                        isMulti
                        placeholder="Select Kulam"
                        onChange={(selected) => handleMultiChange("kulam", selected)}
                        value={KulamList.filter(opt => form.kulam.includes(opt.value))}
                    /> */}

                    {/* <Select
                        options={ColorList}
                        isMulti
                        placeholder="Select color"
                        onChange={(selected) => handleMultiChange("color", selected)}
                        value={ColorList.filter(opt => form.color.includes(opt.value))}
                    /> */}

                </div>

                <div className="search-btn-wrapper">
                    <button onClick={handleAdvancedSearch}>{Loader ? "Loading .... " : "Search"}</button>
                </div>
            </div>
            <div className="result mt-5">
                {Result.length >= 1 && (
                    <h4 className='text-center text-primary fw-bold '>Search Result</h4>
                )}

                <div className="row p-5">
                    {currentProfiles.map((profile, index) => (
                        <div className="col-xl-6 col-12 mb-4" key={index}>
                            <CommonProfileCard profile={profile} setReload={setReload} />
                        </div>
                    ))}
                </div>
                {Result.length > profilesPerPage && (
                    <nav className="d-flex justify-content-center mt-4">
                        <ul className="pagination shadow-sm rounded-3">
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Prev</button>
                            </li>
                            {getPageNumbers().map((page, i) => (
                                <li key={i} className={`page-item ${currentPage === page ? "active" : ""} ${page === "..." ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => typeof page === "number" && handlePageChange(page)}
                                    >
                                        {page}
                                    </button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                )}

            </div>
        </>

    );
}

export default AdvnaceSearch